export default __webpack_public_path__ + "media/images/react_icons/info-2-5d02d0ec16eadfc703434d1cfc2ca2ce.svg";